<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Добавить домофон</h2>
        <el-form
          class="page__form"
          id="formCreateSipServer"
          :model="sip_server"
          ref="form"
          :rules="rules"
          label-position="right"
          label-width="200px"
        >
          <el-form-item label="IP-адрес" prop="ip">
            <el-input placeholder="0.0.0.0" id="ip" size="small" v-model="sip_server.ip" />
          </el-form-item>
          <el-form-item label="Порт сервиса" prop="port_service">
            <el-input placeholder="Порт сервиса управления конфигурациями" id="port_service" size="small" v-model="sip_server.port_service" />
          </el-form-item>
          <el-form-item label="Порт для домофонов" prop="port_intercom">
            <el-input placeholder="Порт для домофонов" id="port_intercom" size="small" v-model="sip_server.port_intercom" />
          </el-form-item>
          <el-form-item label="Порт для устройств" prop="port_client_device">
            <el-input placeholder="Порт для устройств" id="port_client_device" size="small" v-model="sip_server.port_client_device" />
          </el-form-item>
          <el-form-item label="Логин" prop="login">
            <el-input placeholder="Логин сервиса управления конфигурациями" id="login" size="small" v-model="sip_server.login" />
          </el-form-item>
          <el-form-item label="Пароль" prop="password">
            <el-input type="password" placeholder="Пароль сервиса управления конфигурациями" id="password" size="small" v-model="sip_server.password" :readonly="!$can('update', 'sip_servers')"/>
          </el-form-item>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button class="page__active_button" id="submit" icon="el-icon-check" type="primary" @click="submit">
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapActions } from "vuex";
import { required, length, validatorNumber, validatorIp } from "@/core/helpers/validators";

export default {
  name: "FormCreateSipServer",
  data() {
    return {
      sip_server: {
        ip: null,
        port_service: "",
        port_intercom: "",
        port_client_device: "",
        login: null,
      },
      rules: {
        ip: [required(), validatorIp],
        port_service: [validatorNumber],
        port_intercom: [validatorNumber],
        port_client_device: [validatorNumber],
        login: [required()],
        password: [required()]
      },
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.create(this.sip_server)
            .then((id) => {
              this.$message({
                message: "SIP-сервер успешно создан",
                type: "success",
              });
              this.$router.push({ name: "sip-server:edit", params: { id } });
            })
            .catch((e) => {
              this.$message.error(e.response.data.error || "Ошибка при добавлении SIP-сервера");
            });
        }
        return valid;
      });
    },
    ...mapActions("sip_server", {
      create: "ADD_SIP_SERVER",
    }),
  },
};
</script>
